module.exports = __webpack_public_path__ + "static/WEDDING E&M-515-47db16575b72e79372e5956f7ffe2bc8.jpg";